<template>
  <model-list-select   
    class="form-control h-100"
    :style="'border-radius: 0px 4px 4px 0px; width: 1%; ' + (disabled ? 'background-color: #adb5bd; color: #000 !important;' : '')"
    :isDisabled="disabled"
    :list="items" 
    v-model="selectedItem"
    :option-value="valueField"
    :option-text="textField"
    :placeholder="placeHolder" 
    :filterPredicate="(inputText) => new RegExp(inputText, '/\w+\s/g')"
    @searchchange="$emit('searchchange', $event)"
    v-debounce:500ms="debounceSearch"
  />
</template>

<script>
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { ModelListSelect } from 'vue-search-select'

export default {
  name: "input-search-select",
  components: { ModelListSelect },

  props: {
    value:{
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    placeHolder: {
      type: String,
      default: null
    },
    textField: {
      type: String,
      default: 'text'
    },
    valueField: {
      type: String,
      default: 'value'
    }
  },

  data: function() {
    return {

    }
  },

  computed: {
    selectedItem: {
      get() {        
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },

  methods: {
    debounceSearch(val, e) {
      if(val === null || val === undefined || val === "") return

      this.$emit('debounceSearch', val)
    }
  }
}
</script>